var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDetailsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_214_100300)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 4.5H3C2.60218 4.5 2.22064 4.65804 1.93934 4.93934C1.65804 5.22064 1.5 5.60218 1.5 6V21C1.5 21.3978 1.65804 21.7794 1.93934 22.0607C2.22064 22.342 2.60218 22.5 3 22.5H24C24.3978 22.5 24.7794 22.342 25.0607 22.0607C25.342 21.7794 25.5 21.3978 25.5 21V6C25.5 5.60218 25.342 5.22064 25.0607 4.93934C24.7794 4.65804 24.3978 4.5 24 4.5ZM24 21H3V6H24V21Z",
    fill: "#6d4096"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.75 10.5H20.25C20.4489 10.5 20.6397 10.421 20.7803 10.2803C20.921 10.1397 21 9.94891 21 9.75C21 9.55109 20.921 9.36032 20.7803 9.21967C20.6397 9.07902 20.4489 9 20.25 9H6.75C6.55109 9 6.36032 9.07902 6.21967 9.21967C6.07902 9.36032 6 9.55109 6 9.75C6 9.94891 6.07902 10.1397 6.21967 10.2803C6.36032 10.421 6.55109 10.5 6.75 10.5Z",
    fill: "#6d4096"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.75 13.5H20.25C20.4489 13.5 20.6397 13.421 20.7803 13.2803C20.921 13.1397 21 12.9489 21 12.75C21 12.5511 20.921 12.3603 20.7803 12.2197C20.6397 12.079 20.4489 12 20.25 12H6.75C6.55109 12 6.36032 12.079 6.21967 12.2197C6.07902 12.3603 6 12.5511 6 12.75C6 12.9489 6.07902 13.1397 6.21967 13.2803C6.36032 13.421 6.55109 13.5 6.75 13.5Z",
    fill: "#6d4096"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.75 16.5H14.25C14.4489 16.5 14.6397 16.421 14.7803 16.2803C14.921 16.1397 15 15.9489 15 15.75C15 15.5511 14.921 15.3603 14.7803 15.2197C14.6397 15.079 14.4489 15 14.25 15H6.75C6.55109 15 6.36032 15.079 6.21967 15.2197C6.07902 15.3603 6 15.5511 6 15.75C6 15.9489 6.07902 16.1397 6.21967 16.2803C6.36032 16.421 6.55109 16.5 6.75 16.5Z",
    fill: "#6d4096"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_214_100300"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 27,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetailsIcon);
export default __webpack_public_path__ + "static/media/detailsIcon.fd6348a98be9e7c1b4319cec78fb0ec2.svg";
export { ForwardRef as ReactComponent };